'use client';

import React from 'react';
import Toast from './Toast';
import { RootState } from '@/store';
import { useDispatch } from 'react-redux';
import { removeToast } from '@/store/slices/toastSlice';
import { useAppSelector } from '@/hooks/redux';

const ToastRoot: React.FC = () => {
  const toasts = useAppSelector((state: RootState) => state.toast.toasts);
  const dispatch = useDispatch();

  React.useEffect(() => {
    toasts.forEach((toast) => {
      setTimeout(
        () => {
          dispatch(removeToast(toast.id));
        },
        (toast.duration || 5) * 1000 + 1
      );
    });
  }, [toasts]);

  return (
    <>
      {toasts.map((toast) => (
        <Toast key={toast.id} {...toast} />
      ))}
    </>
  );
};

export default ToastRoot;
